import * as React from 'react';
const SvgRefresh = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="nonzero">
         <path d="M28 13.15c4.808 0 9.234 2.303 12.011 6.116a14.8 14.8 0 0 1 2.548 5.795 1.35 1.35 0 0 1-2.647.532 12.1 12.1 0 0 0-2.083-4.737A12.13 12.13 0 0 0 28 15.85c-6.71 0-12.15 5.44-12.15 12.15S21.29 40.15 28 40.15c4.038 0 7.739-1.982 9.996-5.24a12.1 12.1 0 0 0 1.896-4.405 1.35 1.35 0 0 1 2.642.553 14.8 14.8 0 0 1-2.319 5.389A14.83 14.83 0 0 1 28 42.85c-8.201 0-14.85-6.649-14.85-14.85S19.799 13.15 28 13.15" />
         <path d="M41.682 18.707a1.35 1.35 0 1 1 2.636.586l-1.5 6.75a1.35 1.35 0 0 1-1.922.914l-6-3a1.35 1.35 0 0 1 1.208-2.414l4.453 2.226z" />
      </g>
   </svg>
);
export default SvgRefresh;
